import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Card } from 'components/ui'

const FlashMessage = () => {
  const message = useSelector(store => store.flash.message)
  const style = useSelector(store => store.flash.style)
  const link = useSelector(store => store.flash.link)

  useEffect(() => {
    if (!!message) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }, [message])

  if (!!!message) {
    return null
  }

  return (
    <Card color={style === 'error' ? 'red' : 'green'} className="mb-12">
      <span className="text-2xl">{message}</span>
      {link && (
        <Link to={link.to} className="text-2xl font-semibold ml-2 underline">
          {link.label}
        </Link>
      )}
    </Card>
  )
}

export default FlashMessage
